import _extends from 'babel-runtime/helpers/extends';

import resourceMixin from '@/views/creative/mixin/resource.js';

export default {
  mixins: [resourceMixin],

  props: {
    templateConfig: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    resource: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    index: {
      type: Number,
      required: true
    },
    buttonAttrs: Object,
    updateCurrentCategory: Function,
    updateCurrentResource: Function,
    updateCurrentResourceInZip: Function,
    openAddLocalResourceInZipDialog: Function,
    page: {
      type: String,
      required: true
    }
  },

  computed: {
    innerButtonAttrs: function innerButtonAttrs() {
      return _extends({
        type: 'text',
        text: this.$t('playTurbo.creative.updateResourceInZipButton.text'),
        disabled: !this.isUpdatable
      }, this.buttonAttrs);
    },
    isUpdatable: function isUpdatable() {
      if (this.page === 'custom') {
        return true;
      }
      return this.resource && this.resource.is_basic !== 1;
    }
  },

  methods: {
    getPreviewExtras: function getPreviewExtras(val, index) {
      if (val && val[index]) {
        try {
          return JSON.parse(val[index]);
        } catch (e) {
          this.$message.error('' + this.category.name + this.$t('playTurbo.creative.updateResourceInZipButton.error'));
        }
      }
      return {};
    },
    getFileMeta: function getFileMeta(resource, index) {
      var extras = this.getPreviewExtras(resource.preview_extras, index);
      return {
        name: extras.file_name,
        width: extras.width,
        height: extras.height,
        fileSize: extras.file_size
      };
    },
    open: function open() {
      this.updateCurrentCategory(this.category);
      this.updateCurrentResource(this.resource);
      this.updateCurrentResourceInZip(_extends({
        index: this.index,
        url: this.resource.preview_urls[this.index]
      }, this.getFileMeta(this.basicResource, this.index)));
      this.openAddLocalResourceInZipDialog();
    }
  }
};